import { render, staticRenderFns } from "./WordExam.vue?vue&type=template&id=0f88e4a1&scoped=true&"
import script from "./WordExam.vue?vue&type=script&lang=js&"
export * from "./WordExam.vue?vue&type=script&lang=js&"
import style0 from "./WordExam.vue?vue&type=style&index=0&id=0f88e4a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88e4a1",
  null
  
)

component.options.__file = "WordExam.vue"
export default component.exports